export type VerificationBusinessTypeValue =
  | "SOLE_PROPRIETOR"
  | "LLP_LLC_PARTNERSHIP"
  | "PRIVATE_LIMITED"
  | "NONPROFIT_GOVT"
  | "OTHER";

/** Stored values that map 1:1 to the business-structure dropdown (excluding OTHER, which may become free text). */
export const VERIFICATION_BUSINESS_TYPE_PRESET_VALUES = [
  "SOLE_PROPRIETOR",
  "LLP_LLC_PARTNERSHIP",
  "PRIVATE_LIMITED",
  "NONPROFIT_GOVT",
] as const;

export function isVerificationBusinessTypePreset(value: string | null | undefined): boolean {
  if (!value) return false;
  return (VERIFICATION_BUSINESS_TYPE_PRESET_VALUES as readonly string[]).includes(value);
}

/** Which verification PDF the selected business structure requires. */
export function getVerificationDocKind(
  value: string | null | undefined
): "affidavit" | "authority" | null {
  if (!value?.trim()) return null;
  if (value === "SOLE_PROPRIETOR" || value === "LLP_LLC_PARTNERSHIP") return "affidavit";
  /* OTHER token, other presets, or custom free text stored in the same field */
  return "authority";
}

export const VERIFICATION_BUSINESS_TYPE_SELECT_DATA: { value: string; label: string }[] = [
  { value: "SOLE_PROPRIETOR", label: "Sole Proprietor" },
  { value: "LLP_LLC_PARTNERSHIP", label: "LLP / LLC / Partnership" },
  { value: "PRIVATE_LIMITED", label: "Private Limited / Ltd / Corporation" },
  { value: "NONPROFIT_GOVT", label: "Non-Profit / Government" },
  { value: "OTHER", label: "Other" },
];

export function formatVerificationBusinessTypeLabel(value: string | null | undefined): string {
  const v = (value ?? "").trim();
  if (!v) return "N/A";
  const opt = VERIFICATION_BUSINESS_TYPE_SELECT_DATA.find((d) => d.value === v);
  if (opt) return opt.label;
  return v;
}
